import { themes } from './themes'

export const DEFAULT_THEME = themes.find(
  (theme) => theme.name === 'midnight_blue'
)
